import { render } from "./MetaBlock.vue?vue&type=template&id=42ec961a&scoped=true"
import script from "./MetaBlock.vue?vue&type=script&lang=js"
export * from "./MetaBlock.vue?vue&type=script&lang=js"

import "./MetaBlock.vue?vue&type=style&index=0&id=42ec961a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-42ec961a"

export default script